import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { AssetManagementControllerFindAllAssetManagementMovementHistory$Params } from 'src/app/api/fn/asset-management/asset-management-controller-find-all-asset-management-movement-history';
import {
  UserItem,
  AssetManagementMovementHistoryItem,
  AssetManagementItem,
  AssetManagementContactHistoryItem,
} from 'src/app/api/models';
import { AssetManagementService, IdentityService } from 'src/app/api/services';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MovementTypeEnum } from '../enums/movement_types_enum.enum';
import { AssetManagementControllerFindAllAssetManagementContactHistory$Params } from 'src/app/api/fn/asset-management/asset-management-controller-find-all-asset-management-contact-history';
import { manipulateToUTCISOString } from 'src/main';
import { BehaviorSubject, debounceTime, distinctUntilChanged, of, switchMap } from 'rxjs';
import { IdentityControllerGetAll$Params } from 'src/app/api/fn/identity/identity-controller-get-all';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';

@Component({
  selector: 'app-modal-contact-history',
  templateUrl: './modal-contact-history.component.html',
  styleUrls: ['./modal-contact-history.component.scss'],
})
export class ModalContactHistoryComponent {
  @ViewChild('dt3') table_contact_history?: Table;

  protected readonly rowsPerPageOptions = [25, 50, 100, 200, 500];

  loading = false;
  users: UserItem[] = [];
  asset_contact_history: AssetManagementContactHistoryItem[] = [];
  totalRecordsContactsHistory: number = 0;
  selectedAsset?: AssetManagementItem;
  question_title: string;

  autocompleteUsers$ = new BehaviorSubject<string>('');
  suggestedUsers: UserItem[] = [];

  frmFilterContactHistory = new FormGroup({
    rangeDates: new FormControl<Date[] | undefined>(undefined),
    related_contact_first_name: new FormControl<string | undefined>(undefined),
    related_contact_last_name: new FormControl<string | undefined>(undefined),
    related_user: new FormControl<UserItem | undefined>(undefined),
  });

  constructor(
    public auth: AuthService,
    private assetMgmtService: AssetManagementService,
    private userService: IdentityService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService
  ) {
    this.question_title = config.data!.question_title;
    this.selectedAsset = config.data!.selectedAsset;
  }

  ngOnInit() {
    //attivo autocomplete users
    this.autocompleteUsers$
      .pipe(
        debounceTime(300),

        switchMap(query => {
          if (query) {
            let params: IdentityControllerGetAll$Params = {
              limit: 15,
              skip: 0,
              query: query,
            };
            return this.userService.identityControllerGetAll(params);
          } else {
            return of({
              data: { list: [] },
            });
          }
        })
      )
      .subscribe({
        next: res => {
          this.suggestedUsers = res.data.list.map(u => ({
            ...u,
            fullName: `${u.name} ${u.last_name}`,
          }));
        },
      });
    this.frmFilterContactHistory.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(v => {
        this.loadAssetContactHistory(this.table_contact_history?.createLazyLoadMetadata());
      });
  }

  filterUsers(event: AutoCompleteCompleteEvent) {
    let query = event.query;
    this.autocompleteUsers$.next(query);
  }

  loadAssetContactHistory(event: TableLazyLoadEvent) {
    const frmValue = this.frmFilterContactHistory.value;
    const rangeDateFrom = frmValue.rangeDates
      ? manipulateToUTCISOString(frmValue.rangeDates[0], false)
      : undefined;
    const rangeDateTo = frmValue.rangeDates
      ? manipulateToUTCISOString(frmValue.rangeDates[1], true, true)
      : undefined;
    const params: AssetManagementControllerFindAllAssetManagementContactHistory$Params = {
      limit: +event.rows!,
      skip: +event.first!,
      registry_end_customer_contact_first_name: frmValue.related_contact_first_name || undefined,
      registry_end_customer_contact_last_name: frmValue.related_contact_last_name || undefined,
      related_user_id: frmValue.related_user ? frmValue.related_user.id : undefined,
      created_on_from: rangeDateFrom,
      created_on_to: rangeDateTo,
      id: this.selectedAsset?.id!,
    };
    this.assetMgmtService
      .assetManagementControllerFindAllAssetManagementContactHistory(params)
      .subscribe({
        next: res => {
          this.asset_contact_history = res.data.list;
          this.totalRecordsContactsHistory = res.data.count;
          this.loading = false;
        },
      });
  }

  clearAssetContactHisotry(table: Table, e: Event) {
    this.frmFilterContactHistory.reset();
  }
}
